import upperFirst from './upper-first';
/**
 * Suffix can be a falsey value so nothing is appended to string.
 * (helps when looping over props & some shouldn't change)
 * Use data last parameters to allow for currying.
 * @param {string} suffix
 * @param {string} str
 */

var suffixPropName = function suffixPropName(suffix, str) {
  return str + (suffix ? upperFirst(suffix) : '');
};

export default suffixPropName;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/utils/suffix-prop-name.js
// module id = KB1b
// module chunks = 0